var map = {
	"./moon.icon": [
		"48d5",
		"chunk-2d0c22cb"
	],
	"./sun-and-moon.icon": [
		"a22e",
		"chunk-2d207b1a"
	],
	"./sun.icon": [
		"fe30",
		"chunk-2d238052"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a6af";
module.exports = webpackAsyncContext;